import { render, staticRenderFns } from "./SettingsPadding.vue?vue&type=template&id=7bddc9f2&"
import script from "./SettingsPadding.vue?vue&type=script&lang=js&"
export * from "./SettingsPadding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports